import React from "react";
import {
  FaFacebookF,
  FaYoutube,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
} from "react-icons/fa";
import { MdEmail, MdPhone } from "react-icons/md";

const TopBar = () => {
  return (
    <>
      <style>
        {`
          /* On mobile: hide the email/phone text but KEEP icons visible */
          @media (max-width: 768px) {
            .contact-text {
              display: none;
            }

            /* Ensure icons stay a readable size on mobile */
            .contact-icon,
            .social-icon {
              font-size: 20px !important;
              line-height: 1;
            }

            /* Slightly reduce padding on very small screens */
            .topbar {
              padding: 6px 10px !important;
            }
          }

          /* 🔔 Ringing Phone Icon Animation */
          .ring-phone-icon {
            animation: ringAnim 0.8s infinite ease-in-out;
            transform-origin: center;
            display: inline-block;
          }

          @keyframes ringAnim {
            0% { transform: rotate(0deg); }
            20% { transform: rotate(15deg); }
            40% { transform: rotate(-15deg); }
            60% { transform: rotate(10deg); }
            80% { transform: rotate(-10deg); }
            100% { transform: rotate(0deg); }
          }

          /* ✨ NICE HOVER EFFECT FOR ALL ICONS */
          .contact-icon, .social-icon {
            transition: transform 0.25s ease,
                        text-shadow 0.25s ease,
                        color 0.25s ease;
            color: inherit;
          }

          /* On hover icons glow + scale (desktop/touch devices will also get a touch-friendly effect) */
          .contact-icon:hover,
          .social-icon:hover {
            transform: scale(1.18);
            color: #16c79a !important;
            text-shadow: 0 0 8px #16c79a;
          }

          /* PHONE ICON hover: stronger glow */
          .ring-phone-icon:hover {
            transform: scale(1.25) rotate(0deg);
            text-shadow: 0 0 12px #16c79a;
          }
        `}
      </style>

      <div className="topbar" style={styles.topBar}>
        <div style={styles.contactInfo}>
          {/* Email */}
          <a href="mailto:supathamayurveda@gmail.com" style={styles.iconLink}>
            <MdEmail className="contact-icon" style={styles.contactIcon} />
            <span className="contact-text" style={styles.link}>
              supathamayurveda@gmail.com
            </span>
          </a>

          {/* Phone (Ringing + Hover Effect) */}
          <a
            href="tel:+918019108877"
            style={{ ...styles.iconLink, marginLeft: 20 }}
          >
            <MdPhone
              className="contact-icon ring-phone-icon"
              style={styles.contactIcon}
            />
            <span
              className="contact-text"
              style={{ ...styles.link, fontWeight: "bold" }}
            >
              80191 08877
            </span>
          </a>
        </div>

        {/* Social Icons */}
        <div style={styles.socialMedia}>
          <a
            href="https://facebook.com"
            className="social-icon"
            style={styles.socialIcon}
            aria-label="Facebook"
          >
            <FaFacebookF />
          </a>
          <a
            href="https://youtube.com"
            className="social-icon"
            style={styles.socialIcon}
            aria-label="Youtube"
          >
            <FaYoutube />
          </a>
          <a
            href="https://twitter.com"
            className="social-icon"
            style={styles.socialIcon}
            aria-label="Twitter"
          >
            <FaTwitter />
          </a>
          <a
            href="https://instagram.com"
            className="social-icon"
            style={styles.socialIcon}
            aria-label="Instagram"
          >
            <FaInstagram />
          </a>
          <a
            href="https://linkedin.com"
            className="social-icon"
            style={styles.socialIcon}
            aria-label="LinkedIn"
          >
            <FaLinkedinIn />
          </a>
        </div>
      </div>
    </>
  );
};

const styles = {
  topBar: {
    backgroundColor: "#004d66",
    color: "white",
    display: "flex",
    justifyContent: "space-between",
    padding: "8px 20px",
    fontSize: 14,
    alignItems: "center",
    width: "100%",
  },
  contactInfo: {
    display: "flex",
    alignItems: "center",
    gap: 15,
  },
  contactIcon: {
    fontSize: 20,
    color: "white",
    verticalAlign: "middle",
  },
  iconLink: {
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    color: "white",
  },
  link: {
    marginLeft: 8,
    color: "white",
    textDecoration: "none",
    fontSize: 14,
  },
  socialMedia: {
    display: "flex",
    gap: 15,
    alignItems: "center",
  },
  socialIcon: {
    color: "white",
    fontSize: 20,
    textDecoration: "none",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
  },
};

export default TopBar;
